import { FC, useCallback } from 'react'

import { Box, useTheme } from '@mui/material'

import { useMedia } from 'utils/customHooks/useMedia'
import { getValueFromKeys } from 'utils/helpers'

import { IColumn } from 'types'

const tableStyles = (column: IColumn) => {
  return {
    inlineSize: column?.width,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: '1 1 auto',
    justifyContent: column?.align ? `flex-${column.align}` : 'flex-start',
  }
}
interface IProps {
  useTableModel: any
  data: any[]
  rowColor?: string
  align?: string
}
const Table: FC<IProps> = ({ useTableModel, data, rowColor, align }) => {
  const theme = useTheme()
  const { isUnder1200px, isUnder1536px } = useMedia()
  const valueFromKeys = useCallback((row: any, keys: string) => getValueFromKeys(row, keys), [])
  const columns = useTableModel()
  const rows = data || []

  return (

    <div className="simple-table-wrapper">
      <table className="simple-table">
        <tbody>
          <tr>
          {columns.map((column: any, i: number) => (
            <th 
              key={i} 
              className={`${column?.cellClass ?? ''}`}
              style={{ 
                width: column.width, 
                textAlign: column.align === 'end' ? 'right' : column.align, 
                background: rowColor || ''
              }}>
              {column.title}
            </th>
          ))}
          </tr>

          {rows &&
            rows?.length > 0 &&
            rows.map((row, i) => (
              <tr key={i}>
                {columns.map((column, i) => {
                  const value = valueFromKeys(row, column.field)
                  const valueObj = row[column.field]
                  return (
                    <td 
                        key={i} 
                        className={`${column?.cellClass ?? ''}`}
                        style={{ 
                          width: column.width, 
                          textAlign: column.align === 'end' ? 'right' : column.align,
                        }}><div style={column.align === 'end' ? {
                          display: 'flex', 
                          justifyContent: 'flex-end', 
                          alignItems: 'center',
                          gap: '5px'} : {}}>
                              {column.format ? column.format(value, row, i, valueObj) : value}
                        </div>
                    </td>
                  )
                })}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
